import { useModuleBEM, useUiStyles } from "@b2bportal/core-themes";
import { CoreUiComponents } from "@b2bportal/core-types";
import defaultStyles from "./Logo.module.scss";
import { useTenantImages } from "@b2bportal/core-themes";

export const Logo = () => {
  const COMPONENT_KEY = CoreUiComponents.Logo;
  const styles = useUiStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const images = useTenantImages();

  return <img className={block} src={images.logo} alt={"Logo"} />;
};
